module.exports = __webpack_public_path__ + "img/nav-vehicle-models-homepage-ford.0e4c0afe.png";